// extracted by mini-css-extract-plugin
export default {"popoverPaper":"OptionsPopover_popoverPaper__2iUum"};